<template>
    <pendo-modal
        v-if="labelToDelete"
        :visible="labelToDelete"
        type="confirmation"
        title="Delete Label?">
        <template #body>
            <div>
                <strong>Warning!</strong> This action <strong>cannot</strong> be undone. <br><br>
                Label '<strong>{{ labelToDelete.name }}</strong>' will be removed from <strong>{{ labelToDelete.items.length }}</strong> guides.
            </div>
        </template>
        <template #footer>
            <pendo-button
                theme="app"
                type="secondary"
                label="Cancel"
                @click="closeModal" />
            <pendo-button
                type="danger"
                theme="app"
                label="Delete"
                :loading="saving"
                @click="onDelete" />
        </template>
    </pendo-modal>
</template>

<script>
import { PendoButton, PendoModal, PendoNotification } from '@pendo/components';
import { mapActions } from 'vuex';

export default {
    name: 'DeleteLabel',
    components: {
        PendoButton,
        PendoModal,
    },
    props: {
        labelToDelete: {
            type: Object,
            default: undefined,
        },
    },
    emits: ['delete-success', 'delete-fail', 'closed'],
    methods: {
        ...mapActions('labels', ['deleteLabel']),
        async onDelete () {
            const labelId = this.labelToDelete.id;
            try {
                await this.deleteLabel({ labelId });
                this.$emit('delete-success', labelId);
                PendoNotification({
                    type: 'success',
                    title: `Label '${this.labelToDelete.name}' was deleted`,
                    duration: 3000,
                });
                this.closeModal();
            } catch {
                this.$emit('delete-fail', labelId);
                PendoNotification({
                    type: 'error',
                    title: 'Label was not deleted',
                    message: `Looks like something went wrong when deleting the label '${this.labelToDelete.name}' . Please refresh and try again.`,
                    duration: 3000,
                });
            }
        },
        closeModal () {
            this.$emit('closed');
        },
    },
};
</script>
